import { Stool } from '~/components/Landing/Stool'

export default function StoolPage() {
  return <Stool />
}